<script setup lang="ts">
    withDefaults(
        defineProps<{
            modifiers?: string | string[]
            icon?: string
            label?: string
        }>(),
        {
            modifiers: undefined,
            icon: undefined,
            label: undefined,
        },
    )
</script>

<template>
    <VvBadge :modifiers class="shrink-0">
        <div class="flex gap-6 items-center">
            <VvIcon v-if="icon" :name="icon" class="w-14 h-14 shrink-0" />
            <slot>
                {{ label }}
            </slot>
        </div>
    </VvBadge>
</template>
